const ProjectDisabled = ({ projectName }) => {
  return (
    <h2 style={{ textAlign: "center" }}>
      Sorry {projectName} project isn't available
    </h2>
  );
};

export default ProjectDisabled;
